function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 113.28,
  y1: 183.06,
  x2: 141.52,
  y2: 155.83,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#2a1700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 173.5,
  y1: 213.73,
  x2: 199.9,
  y2: 188.28,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 237.46,
  y1: 241.94,
  x2: 270.96,
  y2: 209.64,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 78.54,
  y1: 166.57,
  x2: 106.79,
  y2: 139.33,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "81-90");

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "51.18 160.71 232.57 265.87 331.45 208.78 150.89 104.25 51.18 160.71",
  fill: "#efddd8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M149.94,164.62c-6-4.11-12.23-8-17.52-13.06L86.55,179.3l28.59,15.9,42.07-25C154.8,168.31,152.44,166.32,149.94,164.62Z",
  opacity: 0.32,
  fill: "url(#linear-gradient)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M205.81,194.59c-6-4.11-7.26-1.51-12.55-6.57L150,211.76l21,13.41,42.07-25C210.67,198.28,208.3,196.28,205.81,194.59Z",
  opacity: 0.32,
  fill: "url(#linear-gradient-2)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M265.13,224c-6-4.11-7.26-1.51-12.55-6.57l-43.24,23.74,21,13.41L286,223C283.6,221.1,267.62,225.69,265.13,224Z",
  opacity: 0.32,
  fill: "url(#linear-gradient-3)"
});

var _ref8 = /*#__PURE__*/React.createElement("polyline", {
  points: "135.59 143.78 79.07 177.32 50.48 161.42 106.8 127.36",
  opacity: 0.32,
  fill: "url(#linear-gradient-4)"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "177.75 83.09 177.75 119.22 114.15 156.26 114.15 113.63 177.75 83.09",
  fill: "#ffc050"
});

var _ref10 = /*#__PURE__*/React.createElement("polyline", {
  points: "86.11 139.37 86.11 102.78 114.15 118.97 114.15 156.26",
  fill: "#e1a621"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  points: "114.15 156.26 114.15 118.97 86.11 102.78 86.11 139.37 114.15 156.26",
  fill: "#146666"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "113.88 119.4 85.9 103.25 151.29 66.06 177.75 83.09 113.88 119.4",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M147.31,67.45c-4.2-.36-8.62-1.63-11.72-4.5V75.39A12.91,12.91,0,0,0,148.5,88.31h0a12.91,12.91,0,0,0,12.91-12.91V62.74C157,64.53,152,67.86,147.31,67.45Z",
  fill: "#e1a621"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 148.5,
  cy: 62.87,
  rx: 12.91,
  ry: 6.84,
  fill: "#5ed18d"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M148.5,64s-8.78-1.29-11.11-15.5C137.39,48.53,144.88,52.66,148.5,64Z",
  fill: "#5ed18d"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M149.79,62.22s-10.07-18.08,0-30.22A50.66,50.66,0,0,1,149.79,62.22Z",
  fill: "#5ed18d"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M148.5,50.86s-8.78-1.29-11.11-15.5C137.39,35.36,144.88,39.49,148.5,50.86Z",
  fill: "#5ed18d"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M149.57,56.65s-2.2-8.6,10-16.23C159.57,40.42,158.65,48.92,149.57,56.65Z",
  fill: "#5ed18d"
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 148.5,
  cy: 62.87,
  rx: 12.91,
  ry: 6.84,
  fill: "#146666"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M148.5,64s-8.78-1.29-11.11-15.5C137.39,48.53,144.88,52.66,148.5,64Z",
  fill: "#5ed18d"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M149.79,62.22s-10.07-18.08,0-30.22A50.66,50.66,0,0,1,149.79,62.22Z",
  fill: "#5ed18d"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M148.5,50.86s-8.78-1.29-11.11-15.5C137.39,35.36,144.88,39.49,148.5,50.86Z",
  fill: "#5ed18d"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M149.57,56.65s-2.2-8.6,10-16.23C159.57,40.42,158.65,48.92,149.57,56.65Z",
  fill: "#5ed18d"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 113.45,
  cy: 98.02,
  rx: 21.89,
  ry: 12.82,
  fill: "#ff912e"
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  points: "91.56 98.02 91.56 94.32 93.94 97.28 91.56 98.02",
  fill: "#e0944f"
});

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  points: "135.33 94.32 135.33 98.02 132.56 98.02 134.59 95.05 135.33 94.32",
  fill: "#e0944f"
});

var _ref27 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 113.45,
  cy: 94.32,
  rx: 21.89,
  ry: 12.82,
  fill: "#ffb92c"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M124.55,92.61a1.71,1.71,0,0,1,.17,1l-.09.34-4,0a1.82,1.82,0,0,0,.07-.34,1.49,1.49,0,0,0-.24-.73,2.19,2.19,0,0,0-1-.89,4.37,4.37,0,0,0-1.88-.49,4,4,0,0,0-1.78.27q-.84.36-.65.94a3.46,3.46,0,0,0,.85,1.25,15.22,15.22,0,0,1,1.21,1.39,1.46,1.46,0,0,1,.22,1.54,3.44,3.44,0,0,1-1.94,1.51,11.5,11.5,0,0,1-4.23.88,13.54,13.54,0,0,1-4.63-.65l-2.3,1-2.69-1.31,2.23-1a5,5,0,0,1-1.07-1,2.84,2.84,0,0,1-.53-.89,2.93,2.93,0,0,1-.14-.72,1.56,1.56,0,0,1,0-.5l.08-.19h4a3.19,3.19,0,0,0-.1.4,1.7,1.7,0,0,0,.32.91,3,3,0,0,0,1.32,1.13,5.68,5.68,0,0,0,2.32.6,4.83,4.83,0,0,0,2.14-.34q.83-.36.62-.94a3.45,3.45,0,0,0-.88-1.25,12.79,12.79,0,0,1-1.22-1.39,1.43,1.43,0,0,1-.17-1.55,3.73,3.73,0,0,1,2-1.54,11,11,0,0,1,4.06-.8,11.73,11.73,0,0,1,4.33.67l2.29-1,2.51,1.37-2.3,1A3.27,3.27,0,0,1,124.55,92.61Z",
  fill: "#ea8b24"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 113.48,
  cy: 94.48,
  rx: 18.37,
  ry: 10.76,
  fill: "none",
  stroke: "#f7931e",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 113.45,
  cy: 90.96,
  rx: 21.89,
  ry: 12.82,
  fill: "#ff912e"
});

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  points: "91.56 90.96 91.56 87.26 93.94 90.22 91.56 90.96",
  fill: "#e0944f"
});

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  points: "135.33 87.26 135.33 90.96 132.56 90.96 134.59 87.99 135.33 87.26",
  fill: "#e0944f"
});

var _ref33 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 113.45,
  cy: 87.26,
  rx: 21.89,
  ry: 12.82,
  fill: "#ffb92c"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M124.55,85.54a1.71,1.71,0,0,1,.17,1l-.09.34-4,0a1.82,1.82,0,0,0,.07-.34,1.49,1.49,0,0,0-.24-.73,2.19,2.19,0,0,0-1-.89,4.37,4.37,0,0,0-1.88-.49,4,4,0,0,0-1.78.27q-.84.36-.65.94a3.46,3.46,0,0,0,.85,1.25,15.22,15.22,0,0,1,1.21,1.39,1.46,1.46,0,0,1,.22,1.54,3.44,3.44,0,0,1-1.94,1.51,11.5,11.5,0,0,1-4.23.88,13.54,13.54,0,0,1-4.63-.65l-2.3,1-2.69-1.31,2.23-1a5,5,0,0,1-1.07-1,2.84,2.84,0,0,1-.53-.89,2.93,2.93,0,0,1-.14-.72,1.56,1.56,0,0,1,0-.5l.08-.19h4a3.19,3.19,0,0,0-.1.4,1.7,1.7,0,0,0,.32.91,3,3,0,0,0,1.32,1.13,5.68,5.68,0,0,0,2.32.6,4.83,4.83,0,0,0,2.14-.34q.83-.36.62-.94a3.45,3.45,0,0,0-.88-1.25,12.79,12.79,0,0,1-1.22-1.39,1.43,1.43,0,0,1-.17-1.55,3.73,3.73,0,0,1,2-1.54,11,11,0,0,1,4.06-.8,11.73,11.73,0,0,1,4.33.67l2.29-1,2.51,1.37-2.3,1A3.27,3.27,0,0,1,124.55,85.54Z",
  fill: "#ea8b24"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 113.48,
  cy: 87.41,
  rx: 18.37,
  ry: 10.76,
  fill: "none",
  stroke: "#f7931e",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref36 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 104.89,
  cy: 85.56,
  rx: 21.89,
  ry: 12.82,
  fill: "#ff912e"
});

var _ref37 = /*#__PURE__*/React.createElement("polygon", {
  points: "83 85.56 83 81.86 85.38 84.82 83 85.56",
  fill: "#e0944f"
});

var _ref38 = /*#__PURE__*/React.createElement("polygon", {
  points: "126.78 81.86 126.78 85.56 124 85.56 126.03 82.59 126.78 81.86",
  fill: "#e0944f"
});

var _ref39 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 104.89,
  cy: 81.86,
  rx: 21.89,
  ry: 12.82,
  fill: "#ffb92c"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M116,80.15a1.71,1.71,0,0,1,.17,1l-.09.34-4,0a1.82,1.82,0,0,0,.07-.34,1.49,1.49,0,0,0-.24-.73,2.19,2.19,0,0,0-1-.89,4.37,4.37,0,0,0-1.88-.49,4,4,0,0,0-1.78.27q-.84.36-.65.94a3.46,3.46,0,0,0,.85,1.25,15.22,15.22,0,0,1,1.21,1.39,1.46,1.46,0,0,1,.22,1.54A3.44,3.44,0,0,1,107,86a11.5,11.5,0,0,1-4.23.88,13.54,13.54,0,0,1-4.63-.65l-2.3,1-2.69-1.31,2.23-1a5,5,0,0,1-1.07-1,2.84,2.84,0,0,1-.53-.89,2.93,2.93,0,0,1-.14-.72,1.56,1.56,0,0,1,0-.5l.08-.19h4a3.19,3.19,0,0,0-.1.4,1.7,1.7,0,0,0,.32.91,3,3,0,0,0,1.32,1.13,5.68,5.68,0,0,0,2.32.6,4.83,4.83,0,0,0,2.14-.34q.83-.36.62-.94a3.45,3.45,0,0,0-.88-1.25,12.79,12.79,0,0,1-1.22-1.39,1.43,1.43,0,0,1-.17-1.55,3.73,3.73,0,0,1,2-1.54,11,11,0,0,1,4.06-.8,11.73,11.73,0,0,1,4.33.67l2.29-1,2.51,1.37-2.3,1A3.27,3.27,0,0,1,116,80.15Z",
  fill: "#ea8b24"
});

var _ref41 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 104.93,
  cy: 82.02,
  rx: 18.37,
  ry: 10.76,
  fill: "none",
  stroke: "#f7931e",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M124.21,157.76l26-15.44a3.42,3.42,0,0,1,3.49,0l20.55,12.2a3.42,3.42,0,0,1-.06,5.91l-24.83,14.09a3.42,3.42,0,0,1-3.36,0l-21.71-12.21A2.63,2.63,0,0,1,124.21,157.76Z",
  fill: "#146666"
});

var _ref43 = /*#__PURE__*/React.createElement("polygon", {
  points: "122.92 159.99 122.93 155.74 125.86 156.66 125 160.08 122.92 159.99",
  fill: "#146666"
});

var _ref44 = /*#__PURE__*/React.createElement("polygon", {
  points: "175.9 157.18 175.9 153.2 173.42 154.36 174.59 156.66 175.9 157.18",
  fill: "#146666"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M124.21,153.48l26-15.44a3.42,3.42,0,0,1,3.49,0l20.55,12.2a3.42,3.42,0,0,1-.06,5.91l-24.83,14.09a3.42,3.42,0,0,1-3.36,0L124.27,158A2.63,2.63,0,0,1,124.21,153.48Z",
  fill: "#2c9390"
});

var _ref46 = /*#__PURE__*/React.createElement("polygon", {
  points: "146.43 148.1 149.36 146.85 155.55 158.74 152.62 159.99 146.43 148.1",
  fill: "#fff"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M160.69,151.07a9.75,9.75,0,0,1,3.89.73c1,.46,1.54,1,1.54,1.73s-.54,1.27-1.64,1.73a11.49,11.49,0,0,1-7.88-.07c-1-.46-1.54-1-1.54-1.73s.53-1.27,1.63-1.74A9.78,9.78,0,0,1,160.69,151.07Zm2.24,2.46c0-.27-.24-.52-.71-.74a4.13,4.13,0,0,0-1.65-.34,4,4,0,0,0-1.65.28c-.47.2-.71.44-.7.71s.24.52.71.74a4.13,4.13,0,0,0,1.65.34,4,4,0,0,0,1.65-.28c.47-.2.7-.44.7-.71",
  fill: "#fff"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M146.94,153.38c0,.69-.54,1.27-1.64,1.73a11.48,11.48,0,0,1-7.89-.08c-1-.47-1.53-1-1.54-1.73s.55-1.26,1.64-1.73a11.45,11.45,0,0,1,7.88.07C146.42,152.12,146.94,152.69,146.94,153.38Zm-7.18.66a4.13,4.13,0,0,0,1.65.34,4,4,0,0,0,1.65-.28c.47-.2.71-.44.7-.71s-.24-.52-.71-.74a4.53,4.53,0,0,0-3.3-.05c-.47.2-.7.44-.7.71s.24.52.71.74",
  fill: "#fff"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M291.74,57.06a34,34,0,0,0-12,2.87c-6,2.75,12,7.63,12,7.63",
  fill: "#f2ae16"
});

var _ref50 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 293.8,
  cy: 77.38,
  rx: 18.74,
  ry: 20.53,
  transform: "translate(-9.09 101.08) rotate(-19.23)",
  fill: "#ea8b24"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 288.2,
  cy: 78.62,
  rx: 18.74,
  ry: 20.53,
  transform: "translate(-9.81 99.3) rotate(-19.23)",
  fill: "#ffd008"
});

var _ref52 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 288.2,
  cy: 78.62,
  rx: 16.43,
  ry: 17.99,
  transform: "translate(-9.81 99.3) rotate(-19.23)",
  fill: "none",
  stroke: "#f7931e",
  strokeMiterlimit: 10
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M292.13,68.95a6.45,6.45,0,0,1,1.5,1l.43.46L291.66,73q-.16-.18-.44-.45a5.39,5.39,0,0,0-1.19-.71,4.17,4.17,0,0,0-1.86-.44,2.79,2.79,0,0,0-1.85.6,1.81,1.81,0,0,0-.7,1.43,1.71,1.71,0,0,0,1,1.51,9.78,9.78,0,0,0,2.31,1q1.36.39,2.73.91a5.4,5.4,0,0,1,2.33,1.72,4.76,4.76,0,0,1,1,3.05,5.45,5.45,0,0,1-1.33,3.7,6.43,6.43,0,0,1-3.75,2v2.61h-3.5V87.42a9.67,9.67,0,0,1-2-.52,8.92,8.92,0,0,1-1.6-.76,11.94,11.94,0,0,1-1.12-.79,6.28,6.28,0,0,1-.7-.63l-.22-.27L283.1,82q.18.21.52.54a6.32,6.32,0,0,0,1.49.89,5.43,5.43,0,0,0,2.42.56,3.46,3.46,0,0,0,2.27-.69,2.16,2.16,0,0,0,.81-1.73,1.73,1.73,0,0,0-1-1.52,9.39,9.39,0,0,0-2.32-1q-1.37-.38-2.73-.9a5.41,5.41,0,0,1-2.32-1.72,4.76,4.76,0,0,1-1-3.05A5,5,0,0,1,282.65,70a6.12,6.12,0,0,1,3.62-1.93V65.49h3.5v2.61A8.22,8.22,0,0,1,292.13,68.95Z",
  fill: "#ea8b24"
});

var _ref54 = /*#__PURE__*/React.createElement("polygon", {
  points: "296.08 161.32 304.26 165.96 304.26 130.66 310.69 134.36 300.61 110.96 289.88 122.95 296.41 126.51 296.08 161.32",
  fill: "#e1a621"
});

var _ref55 = /*#__PURE__*/React.createElement("polygon", {
  points: "321.56 177 329.74 181.48 329.74 117.92 336.17 121.62 326.09 98.23 315.36 110.22 321.89 113.78 321.56 177",
  fill: "#e1a621"
});

var _ref56 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.14,
  cy: 67.23,
  rx: 26.06,
  ry: 27.2,
  transform: "translate(-8.39 89.31) rotate(-21.05)",
  fill: "#ea8b24"
});

var _ref57 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.04,
  cy: 68.04,
  rx: 24.84,
  ry: 27.2,
  transform: "translate(-8.82 88.61) rotate(-21.05)",
  fill: "#e1a621"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M204.2,62.22,235.41,68,219.59,39.13S205.82,45.89,204.2,62.22Z",
  fill: "#5ed18d"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M235.41,68l23.42-3s-.45-13.38-15.59-21.44a23.67,23.67,0,0,0-21.17,0Z",
  fill: "#3e2928",
  opacity: 0.24
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M247.56,202.37l46.14-4s4.16,3.69,3.36,4.92l-49.5,4.2S245.82,203.39,247.56,202.37Z",
  fill: "#fff",
  opacity: 0.53
});

var _ref61 = /*#__PURE__*/React.createElement("polygon", {
  points: "249.3 211.31 297.86 207.5 296.45 209.4 250.92 213.26 249.3 211.31",
  fill: "#fff",
  opacity: 0.53
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M271.79,224.82c-17.34,0-30.92-9-30.92-20.43S254.45,184,271.79,184s30.92,9,30.92,20.43S289.13,224.82,271.79,224.82Zm0-33.86c-13,0-23.92,6.15-23.92,13.43s11,13.43,23.92,13.43,23.92-6.15,23.92-13.43S284.75,191,271.79,191Z",
  fill: "#e1a621"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M247.27,212.08l-38.16,22.66c-5.53,3.28-.5,11.93,5,8.63l38.16-22.66c5.53-3.28.5-11.93-5-8.63Z",
  fill: "#e1a621"
});

var _ref64 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.24
}, /*#__PURE__*/React.createElement("path", {
  d: "M271.79,224.82c-17.34,0-30.92-9-30.92-20.43S254.45,184,271.79,184s30.92,9,30.92,20.43S289.13,224.82,271.79,224.82Zm0-33.86c-13,0-23.92,6.15-23.92,13.43s11,13.43,23.92,13.43,23.92-6.15,23.92-13.43S284.75,191,271.79,191Z",
  fill: "#3e2928"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.27,212.08l-38.16,22.66c-5.53,3.28-.5,11.93,5,8.63l38.16-22.66c5.53-3.28.5-11.93-5-8.63Z",
  fill: "#3e2928"
}));

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M192.84,84.07a30.08,30.08,0,0,0-8.76,12.84c-3.08,8.49,4.61,22.38,4.61,22.38l12-9.46",
  fill: "#ff8f6f"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M191.52,196.42l-3.25-1.8.82-4.64s4.84.45,5.26,2.18",
  fill: "#003b94"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M192.74,196.35c.73-.45,1.5-.84,2.25-1.25,1.88-1,4.59-2.09,5.74-4a2.24,2.24,0,0,0-.15-2.52c-1.71-2.06-5.42,1.32-7.33-1-.38-.45-.55-7.6-.55-7.6l-7.24,2s-1.23,14.36-1.09,15.25,2.63,1.74,2.63,1.74a6.41,6.41,0,0,0,2.09-.81c.76-.55.07-7.29,1-6.34s1.39,4.63,1.39,4.63A5,5,0,0,0,192.74,196.35Z",
  fill: "#e1a621"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M205.37,203.36l-3.25-1.8.82-4.64s4.84.45,5.26,2.18",
  fill: "#003b94"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M206.6,203.29c.73-.45,1.5-.84,2.25-1.25,1.88-1,4.59-2.09,5.74-4a2.24,2.24,0,0,0-.15-2.52c-1.71-2.06-5.42,1.32-7.33-1-.38-.45-.55-7.6-.55-7.6l-7.24,2s-1.23,14.36-1.09,15.25,2.63,1.74,2.63,1.74a6.41,6.41,0,0,0,2.09-.81c.76-.55.07-7.29,1-6.34s1.39,4.63,1.39,4.63A5,5,0,0,0,206.6,203.29Z",
  fill: "#e1a621"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M181.79,156.67l-2.09,28.52s3.39,4.69,14.79,2.08h0l.11-19.23",
  fill: "#3e2928"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M195,162.32c-.25,2.46,0,29.55,0,29.55s3.15,5.9,16.88,0l-.19-23",
  fill: "#3e2928"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M183,164a55.6,55.6,0,0,0,11.25,5l.09,0a.77.77,0,0,1,1,.39,59.44,59.44,0,0,0,7.38,1.67c3.2.51,5.86-1.86,9.14-2,0-12.59.06-48.47-5.3-56l-15.85-5.3c-.07,1.31-7.7,10.15-7.52,20.92a231.81,231.81,0,0,1-1.44,28.67",
  fill: "#3e2928"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M208,98.45l-1.46,14.45s-11.84.48-16.94-3V97.6",
  fill: "#ff8f6f"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M223.08,88.94l-1.21,1.65a39.65,39.65,0,0,0,1.7-4.12c.34-1-1.2-1.34-1.54-.39l-.18.49q.22-.76.41-1.54a.79.79,0,0,0-1.54-.39,41.19,41.19,0,0,1-1.2,3.95,28.15,28.15,0,0,0,.56-3.49c.1-1-1.48-1-1.58,0a25.09,25.09,0,0,1-.71,4q0-.68-.12-1.36a.8.8,0,0,0-.33-.57c0-.18-.1-.35-.16-.53a.8.8,0,0,0-1.55.24l-.1,6a7.11,7.11,0,0,1-1.11,1.7,27.61,27.61,0,0,1,2.21,1.72,22.76,22.76,0,0,1,1.8,1.73q.76-.95,1.47-1.94a.86.86,0,0,0,.15-.17q2.13-3.14,4.39-6.18C225.06,88.91,223.68,88.13,223.08,88.94Z",
  fill: "#ffb5a9"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M200.51,85.28s5.59,1.51,7.86,5.13a63.93,63.93,0,0,1,3.74,7.73l4.13-6.42s5,1.54,7,4c0,0-6,13-11.13,14.12s-10.68-7.7-10.68-7.7-1.14,3.66-.92-.25",
  fill: "#ff8f6f"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M204.07,99.17a11.33,11.33,0,0,1-3.54-5c-.67-2.28.17-4.29,1-6.42a20.68,20.68,0,0,0,1.46-6.6c.07-2.23-.19-4.45-.34-6.67a.64.64,0,0,1,0-.29c-.74-2.51-2.28-4.63-5.3-4.88-7.81-.66-8.25,8-8.19,11.5s.43,5.89-2.16,7.37-4.46,5.32-2,8.44.25,2-1.39,4.75-1.22,6.23,2.16,7.48,19.1-1.1,20.55-2.56a3,3,0,0,0,.74-2.12A8.24,8.24,0,0,0,204.07,99.17Z",
  fill: "#007f68"
});

var SvgEquity = function SvgEquity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 400 300",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEquity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/equity.0223afa2.svg";
export { ForwardRef as ReactComponent };